import { Playground } from '../../../components/playground/Playground';
import { Headline } from '../../../components/Headline';
import { Title } from '../../../components/Title';

import { icons, getIconNames } from '../../../utils/icons';

const humanIcons = [...getIconNames(icons.humans)] as string[];

export const IconDisabled = () => (
    <div className='uikit-icons'>
        <Headline headlineType='h3' anchor='disabledIcons'>
            Disabled icons
        </Headline>
        <Playground example={iconDisabledIconsExample} />
    </div>
);

const iconDisabledIconsExample = (
    <div className='display-flex flex-wrap gap-50'>
        <div>
            <Title>Default</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='uikit-icon icon-wifi uikit-icon-disabled text-size-150pct' />
                <span className='uikit-icon icon-lock uikit-icon-disabled text-size-150pct' />
                <span className='uikit-icon icon-globe uikit-icon-disabled text-size-150pct' />
                <span className='uikit-icon icon-api uikit-icon-disabled text-size-150pct' />
                <span className='uikit-icon icon-chat uikit-icon-disabled text-size-150pct' />
            </div>
        </div>
        <div>
            <Title>With red line</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='uikit-icon icon-wifi uikit-icon-disabled uikit-icon-disabled-danger text-size-150pct' />
                <span className='uikit-icon icon-lock uikit-icon-disabled uikit-icon-disabled-danger text-size-150pct' />
                <span className='uikit-icon icon-globe uikit-icon-disabled uikit-icon-disabled-danger text-size-150pct' />
                <span className='uikit-icon icon-api uikit-icon-disabled uikit-icon-disabled-danger text-size-150pct' />
                <span className='uikit-icon icon-chat uikit-icon-disabled uikit-icon-disabled-danger text-size-150pct' />
            </div>
        </div>
        <div>
            <Title>Inverse</Title>
            <div className='display-flex flex-wrap gap-10 text-size-h2'>
                <span className='uikit-icon icon-wifi uikit-icon-disabled uikit-icon-disabled-inverse text-size-150pct' />
                <span className='uikit-icon icon-lock uikit-icon-disabled uikit-icon-disabled-inverse text-size-150pct' />
                <span className='uikit-icon icon-key uikit-icon-disabled uikit-icon-disabled-inverse text-size-150pct' />
                <span className='uikit-icon icon-api uikit-icon-disabled uikit-icon-disabled-inverse text-size-150pct' />
                <span className='uikit-icon icon-wrench uikit-icon-disabled uikit-icon-disabled-inverse text-size-150pct' />
            </div>
        </div>
    </div>
);
